import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authentication/reducer";
import locationsReducer from "./locations/reducer";
import complaintsReducer from "./complaints/reducer";
import statusReducer from "./status/reducer";

const authPersistConfig = {
  key: "auth",
  storage,
  blacklist: ["loading"]
};

const locationsPersistConfig = {
  key: "locations",
  storage,
  blacklist: ["loading", "data"]
};

const complaintsPersistConfig = {
  key: "complaints",
  storage,
  blacklist: ["loading"]
};

const statusPersistConfig = {
  key: "status",
  storage,
  blacklist: ["code", "message"]
};

const rootPersistConfig = {
  key: "root",
  storage,
  blacklist: ["auth", "locations", "complaints", "status"]
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  locations: persistReducer(locationsPersistConfig, locationsReducer),
  complaints: persistReducer(complaintsPersistConfig, complaintsReducer),
  status: persistReducer(statusPersistConfig, statusReducer)
});

export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
